import { render, staticRenderFns } from "./detailed.vue?vue&type=template&id=d23567c8&scoped=true&"
import script from "./detailed.vue?vue&type=script&lang=js&"
export * from "./detailed.vue?vue&type=script&lang=js&"
import style0 from "./detailed.vue?vue&type=style&index=0&id=d23567c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23567c8",
  null
  
)

export default component.exports